import { Component, OnInit, OnChanges, Injector } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { FormField } from 'src/app/core/models/artifact.model';
import { AppWizService } from 'src/app/core/services/app-wiz.service';
import { ArtifactBaseComponent } from '../artifact-base-component';

@Component({
  selector: 'app-form-section-artifact',
  templateUrl: './form-section-artifact.component.html',
  styleUrls: ['./form-section-artifact.component.scss'],
})
export class FormSectionArtifactComponent extends ArtifactBaseComponent implements OnInit, OnChanges {

  fields: FormField[] = [];

  constructor(
    private injector: Injector,
    private fb: FormBuilder,
    public override appWizService: AppWizService
  ) {
    super(injector);
  }

  override ngOnInit(): void {
    this.fields = this.artifact?.formSchema?.fields ?? [];
    this.interalForm = this.buildForm(this.fields);
    this.interalForm.valueChanges.subscribe(() => this.validateSection());
    super.ngOnInit();
  }

  private buildForm(fields: FormField[]): FormGroup {
    const group: { [key: string]: FormControl } = {};
    for (const field of fields) {
      const validators: ValidatorFn[] = [];
      if (field.required) validators.push(Validators.required);
      if (field.maxLength) validators.push(Validators.maxLength(field.maxLength));
      group[field.name] = new FormControl('', validators);
    }
    return this.fb.group(group);
  }

  initJsonData() {
    this.jsonData = this.jsonData || {};
    const patch: { [key: string]: any } = {};
    for (const field of this.fields) {
      patch[field.name] = this.jsonData[field.name] ?? '';
    }
    this.interalForm.patchValue(patch, { emitEvent: false });
  }

  validateJsonData() {
    this.artifact.sectionValid = this.interalForm.valid;
  }

  resetJsonData() {
    this.jsonData = {};
    this.interalForm.reset();
  }

  override processBeforeSubmit() {
    const out: { [key: string]: any } = {};
    for (const field of this.fields) {
      out[field.name] = this.interalForm.value[field.name] ?? '';
    }
    this.jsonData = out;
  }
}
